import { Box, Divider, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { RatingTypography } from "components";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export const ReviewEditDraft = ({ review, canEdit, onStartEdit, onDeleteDraft }) => (
  <Box mt={2}>
    <Divider />
    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
      <Box>
        <Typography variant="body2" fontWeight="bold" color="warning.main">
          Edited Review
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {dayjs(review.editDraft.editedDate).fromNow()}
        </Typography>
        <RatingTypography rating={review.editDraft.rating} />
        <Typography variant="body2" mt={1}>
          {review.editDraft.description}
        </Typography>
      </Box>
      <Box display="flex" gap={0.5} flexShrink={0}>
        {canEdit && review.status === "pendingEdit" && (
          <IconButton
            size="small"
            onClick={() => onStartEdit(review)}
            disabled={review.status === "pendingDelete"}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        )}
        <IconButton size="small" onClick={() => onDeleteDraft(review.id)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  </Box>
);